import Collection from 'core/model/Collection';

import ProviderModel from './ProviderModel';

class SuggestedProviderCollection extends Collection {
  get model() {
    return ProviderModel;
  }

  get url() {
    return '/api/ui/cost/suggestedProviders';
  }

  get defaultSortState() {
    return {
      field: 'provider',
      direction: 'asc'
    };
  }
}

export default SuggestedProviderCollection;
